import { createStyles, makeStyles } from '@material-ui/styles';
import themes from 'styles/themes';
// TODO: why have both component and components folder
export const useStyles = makeStyles(() =>
    createStyles({
        wrapper: {
            margin: 0,
            position: 'absolute',
            left: '50%',
            width: '100%',
            backgroundColor: 'transparent',
            right: 0,
            top: 0,
            bottom: 0,
            zIndex: 199,
            overflow: 'hidden',
        },
        main: {
            height: '100%',
        },
        textCheckout: {
            color: themes.palette.common.white,
            fontWeight: 600,
            fontSize: '14px',
            paddingRight: '11px',
        },
        popupClose: {
            width: '100%',
            background: '#000',
            opacity: 0.5,
        },
        popupMain: {
            backgroundColor: '#f2f2f2',
            padding: '0 24px 0 24px',
            borderRadius: '20px 20px 0px 0px',
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
        },
        popupContent: {
            height: 'auto',
            overflowY: 'scroll',
        },
        bagItem: {
            width: '100%',
            display: 'flex',
            padding: '20px 0 ',
            borderBottom: '1px solid #E8F0F1',
            fontFamily: 'PoppinsRegular',
        },
        itemImg: {
            borderRadius: '4px',
        },
        itemDetail: {
            flex: 1,
            paddingLeft: '10px',
            display: 'flex',
            flexDirection: 'column',
        },
        itemPrice: {
            flex: 1,
            color: themes.palette.primary.main,
            fontSize: 16,
            fontWeight: 600,
            lineHeight: '20px',
        },
        groupQuantity: {
            padding: '6px',
            border: '1px solid #E8F0F1',
            borderRadius: '29px',
            display: 'flex',
        },
        itemQuantity: {
            color: themes.palette.primary.main,
            fontSize: 14,
            fontWeight: 400,
            lineHeight: '20px',
            padding: '0 12px',
        },
        itemName: {
            display: 'flex',
            justifyContent: 'space-between',
            paddingRight: '10px',
            color: themes.palette.primary.main,
            fontSize: 16,
            fontWeight: 600,
            lineHeight: '20px',
        },
        itemDes: {
            color: themes.palette.primary.main,
            fontSize: 14,
            fontWeight: 400,
            lineHeight: '15px',
            opacity: 0.5,
            marginTop: '10px',
        },
        totalPrice: {
            fontWeight: 600,
            color: themes.palette.primary.main,
            fontSize: '16px',
            display: 'flex',
            justifyContent: 'space-between ',
            paddingTop: '20px',
            paddingBottom: '20px',
        },
        popupTitle: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '18px 0 0 0',
        },
        popupTitleText: {
            flex: 1,
            fontSize: 18,
            fontWeight: 600,
            color: themes.palette.primary.main,
            fontFamily: 'PoppinsRegular',
            margin: 0,
            textAlign: 'center',
            paddingLeft: 24,
        },
        bottomPopupTitleText: {
            fontFamily: 'Fraunces',
        },
        popupTitleIcon: {
            color: themes.palette.primary.main,
        },
        popupTitleIconLight: {
            color: themes.palette.primary.light,
        },
        customCloseIcon: {
            position: 'absolute',
            top: '17px',
            right: '17px',
            zIndex: 999,
        },
        popoverContainer: {
            padding: '10px 16px 6px 16px',
        },
        popoverText: {
            fontFamily: 'PoppinsRegular',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontsize: '14px',
            lineHeight: '20px',
            color: themes.palette.primary.main,
        },
    }),
);
